import { ICreateMotivoDemissaoUseCase } from "../../../presentation/useCases/create/create_motivo_demissao_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * CreateMotivoDemissaoUseCase
 */

export class CreateMotivoDemissaoUseCase implements ICreateMotivoDemissaoUseCase {
  constructor(
    private readonly repository: IRhRepository,
  ) { }

  async createMotivoDemissao(
    ativo: number,
    descricaoMotivo: string,
  ): Promise<number> {
    return await this.repository.createMotivoDemissao(
      ativo === 1,
      descricaoMotivo,
    );
  }
}